import { useContext } from 'react'
import { BrandConfig, EnvConfig } from 'src/configurations'

import { ConfigContext, ConfigContextValue } from './ConfigContext'

export default function useConfig(): ConfigContextValue {
  const config = useContext(ConfigContext)

  return config
}

export function useEnvConfig(): EnvConfig {
  const config = useContext(ConfigContext)

  return config.environment
}

export function useCurrentBrand(): BrandConfig {
  const config = useContext(ConfigContext)

  return config.brand
}
